
export function formatSupplyOrderId(id: number): string {
    return `#SO-${id.toString().padStart(5, '0')}`;
}

export default formatSupplyOrderId;
